const translations = {
  "en": {
    "All today's alerts summarized and clarified to save your time.": "All today's alerts summarized and clarified to save your time.",
    "Ask": "Ask",
    "Daily Market Summary": "Daily Market Summary",
    "Generate": "Generate",
    "Give me more info about this report": "Give me more info about this report",
    "Preparing your market summary, simple, sharp, ready to execute": "Preparing your market summary, simple, sharp, ready to execute"
  },
  "zh-tw": {
    "All today's alerts summarized and clarified to save your time.": "今日提醒，一文彙總。為你提煉重點，節省寶貴時間。",
    "Ask": "提問",
    "Daily Market Summary": "每日市場解讀",
    "Generate": "生成",
    "Give me more info about this report": "了解此報告詳情",
    "Preparing your market summary, simple, sharp, ready to execute": "正在準備你的市場摘要，簡單、銳利、可立即執行"
  }
};

export default translations;
